<template>
  <header>
    <p class="title">
      <img v-if="isSmartPhone" src="@/assets/img/header_copy.svg" alt="厚さは速さだ">
      <img v-else src="@/assets/img/header_copy_pc.svg" alt="厚さは速さだ">
    </p>
    <!-- <p class="text"><img src="@/assets/img/header_text1.svg" alt="2019.1.2-3 勝つ気ならナイキ"></p> -->
    <p class="text">
      <img src="@/assets/img/header_text2.svg" alt="2019.1.2-3 結果が語る厚底の速さ">
    </p>
  </header>
</template>

<script>
import isMobile from "ismobilejs";

export default {
  name: "HeaderComponent",
  props: {
    status: String
  },
  data() {
    return {
      isSmartPhone: isMobile.phone
    };
  }
};
</script>

<style scoped lang="scss">
.title {
  padding: vw(15) 0 vw(30);
}
.text {
  width: vw(432);
  margin: 0 auto vw(30);
}
@media #{$mq-md} {
  .title {
    padding: vw(40, 1600) 0 vw(30, 1600);
  }
  .text {
    width: vw(750, 1600);
    margin: 0 auto vw(60, 1600);
    >img {
      max-width: initial;
      width: 100%;
    }
  }
}
</style>
